import React, {useContext} from "react";
import {createUseStyles, useTheme} from "react-jss";
import {EngageAppContext} from "../../App";
import GameCompleteHost from "./GameCompleteHost";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import useMediaQuery from "engage-client/hooks/useMediaQuery";
import {Theme} from "engage-client/theme";
import {Role} from "engage-common/types";

const useStyles = createUseStyles<Theme>((theme) => ({
	gameComplete: {
		position: "fixed",
		left: 0,
		top: 0,
		zIndex: 8
	},
	sidebar: {
		background: theme.gameComplete.background,
		width: "87px",
		top: 0,
		left: 0,
		height: "100vh",
		zIndex: 4
	},
	label: {
		left: 20,
		top: 250,
		position: "relative",
		whiteSpace: "nowrap",
		writingMode: "vertical-rl",
		transform: "rotate(-180deg) translate(0, 50%)",
		opacity: 1,
		color: theme.gameComplete.thankYouTextColor,
		zIndex: 6
	},
	host: {
		position: "fixed",
		zIndex: 10,
		bottom: 30,
		left: 6,
	},
	circle: {
		display: theme.gameComplete.decorativeCircles ? "inherit" : "none",
		background: "#614383",
		opacity: .32,
		position: "absolute",
		zIndex: 5,
		borderRadius: "50%"
	},
	mobileBanner: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: "#392E5E",
		height: 100,
		width: "100%",
	},
	mobileLabel: {
		zIndex: 10
	},
	circleContainer: {
		width: 25,
		position: "relative"
	}
}));

export default function GameComplete() {
	const {user, appState} = useContext(EngageAppContext.current);
	const theme = useTheme<Theme>();
	const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
	const classes = useStyles({isLarge});
	
	const streamURL = appState.common.gameOptions.streamUrl ?? "";
	
	
	if(user?.role !== Role.host) {
		if(isLarge) {
			return <div className={classes.gameComplete} data-qa="game-complete">
				<div className={classes.host}>
					{streamURL !== "" && <GameCompleteHost embedURL={streamURL} size="large"/>}
				</div>
				<div className={classes.sidebar}>
					<DisplayText variant={TextVariant.s34reg} className={classes.label}>THANK YOU FOR PLAYING.</DisplayText>
				</div>
				<div className={classes.circle} style={{bottom: 200, left: 36, width: 63, height: 63}}/>
				<div className={classes.circle} style={{bottom: 150, left: -20, width: 48, height: 48}}/>
				<div className={classes.circle} style={{bottom: 100, left: 46, width: 42, height: 42}}/>
				<div className={classes.circle} style={{bottom: 15, left: 2, width: 58, height: 58}}/>
				<div className={classes.circle} style={{bottom: 245, left: 37, width: 23, height: 23}}/>
				<div className={classes.circle}
					 style={{bottom: 190, left: 87, width: 15, height: 88, borderRadius: 0}}/>
			</div>;
		}
		else {
			return <div className={classes.mobileBanner} data-qa="game-complete">
				<div className={classes.mobileLabel}>
					<DisplayText variant={TextVariant.s28reg} color="white">THANK YOU FOR PLAYING.</DisplayText>
				</div>
				<div className={classes.circleContainer}>
					<div className={classes.circle} style={{top: -40, right: 5, width: 84, height: 84}}/>
					<div className={classes.circle} style={{top: -40, left: 0, width: 53, height: 53}}/>
				</div>
				{streamURL !== "" && <GameCompleteHost embedURL={streamURL} size="small"/>}
			</div>;
		}
	}
	return null;
};
